import React, {useEffect, useState} from 'react'
import Select from 'Components/Select'
import Datagrid from '../Table'
import Grid from '@material-ui/core/Grid'
import ApiRequest from 'EurestoApi/ApiRequest'
import project from 'EurestoConfig/project.config'
import Utils from 'EurestoFonction/Utils'
import {browserHistory} from 'react-router'
import useAxiosCancelToken from 'EurestoHook/useAxiosCancelToken'

export default (props) => {

  const [key, setKey] = useState(Utils.getRandomNumber())
  const [input, setInput] = useState('')
  const [etablissementsGroupe, setEtablissementsGroupe] = useState([])
  const [gridLoading, setGridLoading] = useState(true)

  //const debounceSearchTerm = useDebounceSearch(input, 500)

  const { data, loading } = useAxiosCancelToken('crm', 'client', 'list', {
    recherche: Utils.searchJsonToRechercheArray({
      nom: input
    }),
    limit: 5,
    offset: 0
  }, key)

  const onChangeInput = data => {
    setInput(data)
    setKey(Utils.getRandomNumber())
  }

  const getContact = async (search, params = {
    limit: 5,
    offset: 0,
  }) => {
    search = EurestoClone(search)
    return await ApiRequest(project.api + 'crm', {
      requete: 'client',
      action: 'list',
      ...params,
      recherche: Utils.searchJsonToRechercheArray(search)
    })
  }

  useEffect(() => {
    const getListEts = async () => {
      setGridLoading(true)
      const ets = props.data && props.data.length > 0 && await getContact({
        'grc_contact.id': props.data
      }, {
        limit: 10,
        offset: 0
      })
      setEtablissementsGroupe(ets.results || [])
      setGridLoading(false)
    }
    if (props.data && props.data.length > 0) {
      getListEts()
    }
  }, [props.data])

  const update = (row, i, e) => {
    if (e && (e.metaKey || e.crtlKey)) {
      window.open('/crm/' + row.id, '_blank')
    } else {
      browserHistory.push({
        pathname: '/crm/' + row.id
      })
    }
  }

  const onSelectEtablissement = (ets_id) => {
    setEtablissementsGroupe([
      ...etablissementsGroupe,
      data.find(d => d.id === ets_id)
    ])
    props.onChange(ets_id)
  }

  return <Grid container direction={'column'} justify={'flex-start'} alignItems={'stretch'}>
    <Select disabled={props.disabled}
            loading={loading}
            title={'Rechercher un établissement'}
            options={(data || []).map(contact => ({
              label: contact.libelle,
              value: contact.id,
              html:
                <strong>{contact.libelle}</strong>
            }))}
            onChangeText={onChangeInput}
            inputStyle={{ marginBottom: 0 }}
            onChange={onSelectEtablissement}/>

    <Datagrid onClick={update}
              loadding={gridLoading}
              key={etablissementsGroupe}
              view={'list'}
              style={{ maxHeight: 400 }}
              data={etablissementsGroupe}
              type="etablissement"/>
  </Grid>
}



// WEBPACK FOOTER //
// ./app/App/Module/CRM/Component/EtablissementGroupe/index.js